<div class="bg-white flex justify-start flex-col">
  <router-outlet></router-outlet>
</div>
